const t = {
  name: "MagnetStripSwipe",
  dimensions: { width: 28, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 40" style="enable-background:new 0 0 28 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21,19v8h2v-8H21z"/>
		<path class="st0" d="M23,32h-7v8h-2V29c0-1.7-1.3-3-3-3H0v-2h6V5c0-2.8,2.2-5,5-5h12c2.8,0,5,2.2,5,5v22C28,29.8,25.8,32,23,32z
			 M8,5v19h2V2.2C8.8,2.6,8,3.7,8,5z M14,25V2h-2v22.1C12.7,24.3,13.4,24.6,14,25z M16,30h7c1.7,0,3-1.3,3-3V5c0-1.7-1.3-3-3-3h-7
			V30z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as MagnetStripSwipe
};
